module.exports = __webpack_public_path__ + "static/media/kiuas.84b03ed1.png";